<template>
	<div class="marketing-copy-page">
		<!-- 导航栏：统一风格，标题改为AI笔记 -->
		<div class="custom-nav-bar" v-if="currentPlatform !== 'weixin'">
			<div class="back-btn" @click="onBack">
				<img src="@/assets/back.svg" class="back-icon" />
			</div>
			<div class="nav-title">AI笔记</div>
		</div>

		<!-- 主体区域：白色背景+撑满剩余高度+精准padding -->
		<div class="page-body">
			<div class="option-header">
				<img src="@/assets/star.svg" class="star-icon" />
				<div class="top-option-container">
					<div class="option-text" :class="{ active: activeTab === 1 }" @click="switchTab(1)">
						自由创作
					</div>
					<div class="option-text" :class="{ active: activeTab === 2 }" @click="switchTab(2)">
						爆款改写
					</div>
				</div>
			</div>
			<div class="content-card">
				<!-- 多行文本输入框 -->
				<textarea class="text-input" :placeholder="activeTab === 1 ? '请输入笔记内容' : '请粘贴小红书分享链接'" v-model="inputContent"></textarea>
				<!-- 按钮容器（用于靠右对齐） -->
				<div class="btn-wrapper" v-if="activeTab !== 2">
					<div class="submit-btn" @click="handleSubmit">
						<img src="@/assets/xt.svg" class="btn-icon" />
						<!-- 右侧文字 -->
						<div class="btn-text">AI选题</div>
					</div>
				</div>
			</div>

			<div class="customer-group-title" style="margin-left: 2.1333vw;">面向客群</div>

			<div class="kequn-item-container" v-for="(item, idx) in kequn" :key="'kequn-' + idx">
				<!-- 第一行：渐变色块 + title -->
				<div class="kequn-title-wrap">
					<div class="kequn-color-block"></div>
					<div class="kequn-title-text">{{ item.title }}</div>
				</div>

				<!-- 第二行：循环list字段的标签 -->
				<div class="kequn-list-wrap">
					<div class="kequn-list-item" :class="{ active: selectedKequn.includes(listItem.enumName) }"
						@click="toggleKequnItem(listItem.enumName)" v-for="(listItem, listIdx) in item.list"
						:key="'kequn-item-' + idx + '-' + listIdx">
						{{ listItem.enumName }}
					</div>
				</div>
			</div>

			<div class="customer-group-title fengge-title">
				<img src="@/assets/star.svg" class="star-icon" />
				用词风格
			</div>

			<!-- 新增：风格选择盒子（标题下方12px，无标题行，调整padding） -->
			<div class="fengge-item-container" v-for="(item, idx) in fengge" :key="'fengge-' + idx">
				<!-- 直接显示标签行，无kequn-title-wrap -->
				<div class="kequn-list-wrap">
					<div class="kequn-list-item" :class="{ active: selectedFengge.includes(listItem.enumName) }"
						@click="toggleFenggeItem(listItem.enumName)" v-for="(listItem, listIdx) in item.list"
						:key="'fengge-item-' + idx + '-' + listIdx">
						{{ listItem.enumName }}
					</div>
				</div>
			</div>

			<div class="customer-group-title fengge-title emoji-title">
				<img src="@/assets/star.svg" class="star-icon" />
				加入表情
			</div>

			<!-- 新增：是/否单选容器 -->
			<div class="emoji-select-container">
				<div class="emoji-select-item" :class="{ active: selectedEmoji === 'yes' }"
					@click="toggleEmojiItem('yes')">
					是
				</div>
				<div class="emoji-select-item" :class="{ active: selectedEmoji === 'no' }"
					@click="toggleEmojiItem('no')">
					否
				</div>
			</div>

			<div class="customer-group-title fengge-title word-count-title">
				<img src="@/assets/star.svg" class="star-icon" />
				字数
			</div>

			<!-- 新增：字数选择容器 -->
			<div class="word-count-select-container">
				<!-- 300选项 -->
				<div class="word-count-select-item" :class="{ active: selectedWordCount === '300' }"
					@click="toggleWordCountItem('300')">
					300
				</div>
				<!-- 500选项 -->
				<div class="word-count-select-item" :class="{ active: selectedWordCount === '500' }"
					@click="toggleWordCountItem('500')">
					500
				</div>
				<!-- 800选项 -->
				<div class="word-count-select-item" :class="{ active: selectedWordCount === '800' }"
					@click="toggleWordCountItem('800')">
					800
				</div>
				<!-- 自定义选项：包含单行输入框 -->
				<div class="word-count-select-item custom-item" :class="{ active: selectedWordCount === 'custom' }"
					@click="toggleWordCountItem('custom')">
					<input v-if="selectedWordCount === 'custom'" v-model="customWordCount" type="number"
						class="custom-word-input" placeholder="自定义" @input="validateCustomWordCount"
						@blur="validateCustomWordCount" maxlength="4" />
					<span v-else>自定义</span>
				</div>
			</div>

			<div class="generate-btn" @click="handleGenerate">
				AI生成
			</div>
		</div>
		<van-popup v-model="showAiTopicPopup" round position="bottom" :close-on-click-overlay="true">
			<!-- 弹窗主体容器 -->
			<div class="ai-topic-popup-container">
				<!-- 弹窗顶部栏：返回按钮 + 标题 -->
				<div class="ai-topic-popup-header">
					<div class="back-btn-popup" @click="closeAiTopicPopup">
						<img src="@/assets/back_s.svg" class="back-icon-popup" />
					</div>
					<div class="ai-topic-title">AI选题</div>
				</div>
				<div class="ai-topic-divider"></div>

				<!-- 新增：横向滚动盒子 -->
				<div class="ai-topic-scroll-box">
					<div class="ai-topic-tag" v-for="(item, idx) in aiTopicList" :key="'topic-tag-' + idx"
						@click="selectTopic(item)">
						{{ item.enumName }}
					</div>
				</div>

				<div class="ai-topic-list-container">
					<div class="ai-topic-list-item" v-for="(item, idx) in topicList" :key="'topic-item-' + idx" :class="{ 
				      'first-item': idx === 0,
				      'active': selectedTopicItemId === item.id 
				    }" @click="selectTopicItem(item)">
						{{ item.topic }}
					</div>
				</div>
			</div>
		</van-popup>
		<LackModal v-if="showLackTipModal"  @closeModal="closeModal"/>
	</div>
</template>

<script>
	import {
		getSysEnum,
		getTopic,
		createNote
	} from "@/api/poster";
	import LackModal from "@/components/lackModal.vue";
	export default {
		name: "AINotePage",
		components: { LackModal },
		data() {
			return {
				activeTab: 1, // 默认选中1-自由创作
				inputContent: "",
				kequn: [],
				selectedKequn: [],
				fengge: [],
				selectedFengge: [],
				selectedEmoji: 'yes',
				selectedWordCount: '300',
				// 新增：自定义字数存储，初始为空
				customWordCount: '',
				showAiTopicPopup: false,
				aiTopicList: [],
				selectedTopicCode: '',
				topicList: [],
				selectedTopicItemId: '',
				showLackTipModal: false,
				currentPlatform: '',
			};
		},
		mounted() {
			this.getKequn()
			this.getStyle()
			this.getTopic()
			this.currentPlatform = sessionStorage.getItem('h5_uni_platform');
			document.title = "AI笔记";
		},
		methods: {
			async getKequn() {
				try {
					const res = await getSysEnum({
						enumGroup: 'CUSTOMER_BASE' //客群
					});
					console.log('请求结果', res);
					this.kequn = Array.isArray(res) ? res : [];
				} catch (error) {
					console.log(error);
					this.kequn = [];
				}
			},
			async getStyle() {
				try {
					const res = await getSysEnum({
						enumGroup: 'STYLE'
					});
					console.log('请求结果', res);
					this.fengge = Array.isArray(res) ? res : [];
					// // 第二步：安全赋值默认选中项（校验每一层数据是否存在）
					if (this.fengge.length > 0 && Array.isArray(this.fengge[0].list) && this.fengge[0].list.length >
						0) {
						this.selectedFengge = this.fengge[0].list[0].enumName; // 用等号赋值！
					} else {
						// 兜底：接口返回空数据时的默认值（避免无选中项）
						this.selectedFengge = "";
						console.warn("风格接口返回数据异常，无可用选项");
					}
				} catch (error) {
					console.log(error);
					this.fengge = [];
					this.selectedFengge = "";
				}
			},
			async getTopic() {
				try {
					const res = await getSysEnum({
						enumGroup: 'TOPIC_TITLE'
					});
					console.log('请求结果', res);
					// 安全赋值：校验res和res[0].list是否存在
					this.aiTopicList = Array.isArray(res) && res[0] && Array.isArray(res[0].list) ?
						res[0].list : [];
					// 默认选中第一个的enumCode（即使只有一个也赋值）
					if (this.aiTopicList.length > 0) {
						this.selectTopic(this.aiTopicList[0])
						this.selectedTopicCode = this.aiTopicList[0].enumCode;
					}
				} catch (error) {
					console.log(error);
					// 异常时重置数组和选中状态
					this.aiTopicList = [];
					this.selectedTopicCode = '';
				}
			},
			async selectTopic(item) {
				// 1. 判断是否点击当前已选中项，不触发接口
				if (this.selectedTopicCode === item.enumCode) {
					console.log('点击的是当前已选中的选题，不调用接口');
					return;
				}

				// 2. 更新选中状态
				this.selectedTopicCode = item.enumCode;
				console.log('选中的选题code：', this.selectedTopicCode);

				// 3. 调用接口并赋值topicList
				try {
					const res = await getTopic({
						enumCode: this.selectedTopicCode
					});
					console.log('选题详情请求结果', res);
					// 安全赋值：校验res是数组，非数组则置空
					this.topicList = Array.isArray(res) ? res : [];
				} catch (error) {
					console.log('选题详情接口调用失败', error);
					this.topicList = []; // 异常时清空列表
				}
			},
			// 返回按钮逻辑
			onBack() {
				this.$router.back();
			},
			closeModal(){
            	this.showLackTipModal = false;
			},
			switchTab(tabIndex) {
				this.activeTab = tabIndex;
				// 可在此添加标签切换后的业务逻辑
			},
			handleSubmit() {
				this.showAiTopicPopup = true;
				this.selectedTopicItemId = '';
			},
			selectTopicItem(item) {
				// 1. 更新选中状态ID
				this.selectedTopicItemId = item.id;
				// 2. 将选中的topic文字赋值给inputContent
				this.inputContent = item.topic;
				this.showAiTopicPopup = false
				console.log('选中的选题文字：', this.inputContent);
			},
			closeAiTopicPopup() {
				this.showAiTopicPopup = false;
			},
			toggleKequnItem(enumName) {
				if (this.selectedKequn.includes(enumName)) {
					// 取消选中：从数组移除
					this.selectedKequn = this.selectedKequn.filter(item => item !== enumName);
				} else {
					// 选中：添加到数组
					this.selectedKequn.push(enumName);
				}
			},
			toggleFenggeItem(enumName) {
				this.selectedFengge = enumName; // 覆盖为当前点击的字符串，确保单选
			},
			toggleEmojiItem(type) {
				this.selectedEmoji = type;
			},
			toggleWordCountItem(type) {
				this.selectedWordCount = type;
				// 选中非自定义时清空输入框，避免残留
				if (type !== 'custom') {
					this.customWordCount = '';
				}
			},

			// 新增：自定义字数验证（1000以内整数）
			validateCustomWordCount() {
				// 过滤非数字字符
				let num = this.customWordCount.replace(/\D/g, '');
				// 转换为数字，空则置空，超过1000则设为1000
				num = num ? Math.min(parseInt(num), 1000) : '';
				this.customWordCount = num.toString();
			},
			async handleGenerate() {
				// 可整合所有选中的参数（客群、风格、表情、字数等）
				try {
					// 1. 构建接口参数（严格匹配字段要求）
					const params = {
						// type：1=创作(create)，2=改写(rewrite)
						type: this.activeTab === 1 ? 'create' : 'rewrite',
						// content：笔记文案（输入框内容）
						content: this.inputContent.trim(),
						// customerBase：客群（数组转逗号分隔的字符串，接口要求string）
						customerBase: this.selectedKequn.join(','),
						// style：笔记风格
						style: this.selectedFengge,
						// emo：是否加表情（yes→true，no→false，接口要求boolean）
						emo: this.selectedEmoji === 'yes',
						// wordCount：字数（转整数，处理自定义场景，兜底300）
						wordCount: this.getWordCount()
					};

					console.log('生成笔记接口参数：', params);

					// 2. 可选：参数校验（避免空值导致接口报错）
					if (!params.content) {
						// 可替换为项目的提示组件（如van-toast）
						alert('请输入笔记文案');
						return;
					}
					if (!params.customerBase) {
						alert('请选择笔记客群');
						return;
					}
					if (!params.style) {
						alert('请选择笔记风格');
						return;
					}

					// 3. 调用生成接口（替换为你的实际接口方法）
					const res = await createNote(params);
					console.log('生成笔记结果：', res);
					if(res?.status == 'notAllowed'){
            			this.showLackTipModal = true;
					} else {
						this.$router.push({
							path: 'aiTextDetail', // 需在路由配置中注册该页面
							query: {
								titles: JSON.stringify(res.titles), // 数组转JSON字符串传递
								content: res.content
							}
						});
					}

				} catch (error) {
					console.error('生成笔记接口调用失败：', error);
					// 异常提示（可替换为项目的提示组件）
					alert('生成笔记失败，请重试');
				}
			},
			getWordCount() {
				let count = 300; // 默认兜底值
				if (this.selectedWordCount === 'custom') {
					// 自定义字数：非空则转整数，否则用默认值
					count = this.customWordCount ? parseInt(this.customWordCount) : 300;
				} else {
					// 固定字数：直接转整数
					count = parseInt(this.selectedWordCount);
				}
				// 确保字数是整数且≥0（接口要求int32）
				return Math.max(0, count);
			}
		},
	};
</script>

<style scoped>
	/* 页面基础布局：纵向排列+固定视口高度，禁止整体滚动 */
	.marketing-copy-page {
		width: 100vw;
		height: 100vh;
		height: 100dvh;
		background: #f5f6f8;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		overflow: hidden;
		position: fixed;
		top: 0;
		left: 0;
	}

	/* 导航栏：复用原有统一风格 */
	.custom-nav-bar {
		width: 100%;
		height: 11.7333vw;
		background-image: linear-gradient(90deg, #E7F2FA 0%, #DBE2F1 100%);
		box-shadow: 0px 0.1333vw 0px 0px rgba(97, 182, 255, 0.3);
		position: relative;
		z-index: 999;
		display: flex;
		align-items: center;
		justify-content: center;
		box-sizing: border-box;
		flex-shrink: 0;
		/* 禁止导航栏被压缩 */
	}

	.back-btn {
		width: 6.4vw;
		height: 6.4vw;
		position: absolute;
		left: 2.6667vw;
		top: 50%;
		transform: translateY(-50%);
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.back-icon {
		width: 100%;
		height: 100%;
		object-fit: contain;
	}

	.nav-title {
		font-family: SourceHanSansSC-Medium;
		font-size: 4.8vw;
		color: #000000;
		letter-spacing: 0.1333vw;
		text-align: center;
		line-height: 11.7333vw;
		font-weight: 500;
	}

	/* 主体区域：白色背景+撑满剩余高度+精准padding（左右32px 上下40px） */
	.page-body {
		padding: 5.3333vw 4.8vw;
		/* 上40px 下40px 左32px 右32px（750px设计稿转换） */
		box-sizing: border-box;
		background: #FFFFFF;
		flex: 1;
		/* 撑满除导航外所有屏幕高度 */
		min-height: 0;
		/* 兼容弹性布局，防止内容溢出 */
		overflow-y: auto;
		overflow-x: hidden;
		-webkit-overflow-scrolling: touch;
		/* 可选：隐藏滚动条（优化视觉，不影响功能） */
		scrollbar-width: none;
		/* 火狐 */
	}

	.top-option-container {
		display: flex;
		align-items: flex-end;
		/* 底部对齐 */
		gap: 4.2667vw;
		/* 32px = 32/7.5，文字之间间距 */
		box-sizing: border-box;
		/* margin-bottom: 2.1333vw; */
	}

	.option-header {
		display: flex;
		align-items: center;
		/* 与文字垂直居中对齐 */
		box-sizing: border-box;
		margin-bottom: 2.1333vw;
		/* 保留原top-option-container的下间距 */
	}

	.star-icon {
		width: 2.6667vw;
		/* 20px = 20/7.5 */
		height: 2.1333vw;
		/* 16px = 16/7.5 */
		margin-right: 0.8vw;
		/* 6px = 6/7.5，与文字间距 */
		margin-left: -1.3333vw;
		/* 向左入侵父容器左padding 10px = 10/7.5 */
		vertical-align: middle;
		display: inline-block;
		object-fit: contain;
		/* 保证图片不失真 */
	}

	/* 文字选项基础样式（未选中） */
	.option-text {
		font-family: SourceHanSansSC-medium;
		/* 替换字体 */
		color: #666666;
		/* 替换颜色 */
		font-weight: 500;
		/* 替换字重 */
		font-size: 3.7333vw;
		/* 28px = 28/7.5 */
		letter-spacing: -0.1333vw;
		/* -1px = -1/7.5 */
		font-style: normal;
		text-decoration: none;
		text-align: left;
		cursor: pointer;
		/* 保留交互样式 */
		line-height: 1;
		/* 保留底部对齐 */
		/* 移除原有opacity，按新要求未提及则删除 */
	}

	/* 选中状态样式 */
	.option-text.active {
		font-family: SourceHanSansSC-bold;
		/* 替换字体 */
		color: #1F2226;
		/* 替换颜色 */
		font-weight: 700;
		/* 替换字重 */
		font-size: 4.2667vw;
		/* 32px = 32/7.5 */
		letter-spacing: -0.1333vw;
		/* -1px = -1/7.5 */
		/* 移除原有opacity，按新要求未提及则删除 */
	}

	.content-card {
		width: 100%;
		height: 21.3333vw;
		/* 160px = 160/7.5 */
		border-radius: 2.1333vw;
		/* 16px = 16/7.5 */
		background-color: #FFFFFF;
		box-shadow: 0px 0px 1.3333vw 0px rgba(0, 0, 0, 0.18);
		/* 10px = 1.3333vw */
		padding: 1.0667vw 2.1333vw 2.1333vw 2.1333vw;
		/* 上8px 左右下16px */
		box-sizing: border-box;
		display: flex;
		/* 新增：纵向布局 */
		flex-direction: column;
		gap: 1.6vw;
		/* 输入框与按钮间距12px（1.6vw），可调整 */
	}

	.text-input {
		width: 100%;
		flex: 1;
		/* 占满按钮外的所有高度 */
		border: none;
		/* 去掉默认边框 */
		outline: none;
		/* 去掉聚焦边框 */
		resize: none;
		/* 禁止手动调整大小 */
		background: transparent;
		/* 透明背景 */
		font-family: SourceHanSansSC-regular;
		font-size: 3.2vw;
		/* 24px，可根据需求调整 */
		color: #333333;
		line-height: 1.5;
		box-sizing: border-box;
	}

	/* 输入框占位符样式（可选优化） */
	.text-input::placeholder {
		color: #C2C2C2;
		opacity: 0.8;
	}

	/* 按钮容器：靠右对齐 */
	.btn-wrapper {
		width: 100%;
		display: flex;
		justify-content: flex-end;
		/* 按钮靠右 */
	}

	/* 按钮样式 */
	.submit-btn {
		padding: 0.8vw 2.4vw;
		/* 上下6px、左右18px */
		border-radius: 2.6667vw;
		/* 20px */
		opacity: 0.9;
		background-color: #1570EE;
		cursor: pointer;
		box-sizing: border-box;
		/* 核心：flex布局实现整体水平+垂直居中 */
		display: flex;
		align-items: center;
		/* 垂直居中 */
		justify-content: center;
		/* 水平居中 */
		gap: 1.0667vw;
		/* 图标与文字间距8px */
		/* 清除div默认样式影响 */
		line-height: 1;
	}

	/* 按钮内图标 */
	.btn-icon {
		width: 3.2vw;
		/* 24px */
		height: 3.2vw;
		/* 24px */
		object-fit: contain;
		display: block;
	}

	/* 按钮内文字div：单独flex居中（兜底） */
	.btn-text {
		font-family: SourceHanSansSC-regular;
		color: #FFFFFF;
		font-weight: 400;
		font-size: 2.6667vw;
		/* 20px */
		font-style: normal;
		text-decoration: none;
		/* 新增：div自身flex居中，确保文字在容器内居中 */
		display: flex;
		align-items: center;
		justify-content: center;
		line-height: 1;
	}

	.customer-group-title {
		margin-top: 5.3333vw;
		margin-bottom: 1.6vw;
		/* 40px = 40/7.5 */
		opacity: 0.9;
		font-family: SourceHanSansSC-bold;
		color: #1F2226;
		font-weight: 700;
		font-size: 4.2667vw;
		/* 32px = 32/7.5 */
		letter-spacing: -0.1333vw;
		/* -1px = -1/7.5 */
		font-style: normal;
		text-decoration: none;
		text-align: left;
		line-height: 1;
		/* 重置行高，避免间距偏差 */
		display: flex;
		align-items: center;
	}

	.kequn-item-container {
		padding: 1.6vw 1.3333vw 1.6vw 3.2vw;
		/* 12px 10px 12px 24px */
		box-sizing: border-box;
		width: 100%;
	}

	/* 标题行容器：flex水平居中 */
	.kequn-title-wrap {
		display: flex;
		align-items: center;
		box-sizing: border-box;
		margin-bottom: 1.6vw;
		/* 标题与标签行间距12px，可选 */
	}

	/* 渐变色块：宽8px 高24px 圆角4px 渐变背景 */
	.kequn-color-block {
		width: 1.0667vw;
		/* 8px */
		height: 3.2vw;
		/* 24px */
		border-radius: 0.5333vw;
		/* 4px */
		background: linear-gradient(148.76deg, rgba(47, 255, 181, 1) 0%, rgba(30, 137, 255, 1) 100%);
		margin-right: 0.8vw;
		/* 与title间距6px */
		flex-shrink: 0;
		/* 防止色块压缩 */
	}

	/* title文字样式 */
	.kequn-title-text {
		font-family: SourceHanSansSC-medium;
		color: #333333;
		font-weight: 500;
		font-size: 3.2vw;
		/* 24px */
		letter-spacing: 0vw;
		/* 0px */
		font-style: normal;
		text-decoration: none;
		text-align: left;
		line-height: 1;
	}

	/* 标签行容器：上下12px padding 横向排列 换行 */
	.kequn-list-wrap {
		padding: 1.6vw 0;
		/* 上下12px */
		display: flex;
		flex-wrap: wrap;
		/* 显示不下换行 */
		gap: 1.6vw 1.0667vw;
		/* 上下12px 左右8px 间距（换行后上下间距） */
		box-sizing: border-box;
		width: 100%;
	}

	/* 单个标签基础样式 */
	.kequn-list-item {
		padding: 1.4667vw 2.4vw;
		/* 上下11px 左右18px */
		height: auto;
		/* 取消固定height，改为自适应，避免挤压 */
		min-height: 6.4vw;
		/* 保留最小高度48px，保证视觉一致 */
		width: auto;
		border-radius: 1.0667vw;
		/* 8px */
		box-sizing: border-box !important;
		/* 强制生效，避免被覆盖 */
		font-family: SourceHanSansSC-regular;
		font-size: 2.6667vw;
		/* 20px */
		font-weight: 400;
		font-style: normal;
		text-decoration: none;
		text-align: center;
		line-height: 1.5;
		/* 用行高控制文字垂直居中，替代固定height */
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		flex-shrink: 0;
		/* 核心：统一选中/非选中的边框宽度，仅改颜色 */
		border: 0.2667vw solid transparent;
		/* 2px 透明边框，与选中状态宽度一致 */
	}

	/* 标签未选中状态：仅改背景+文字颜色，边框保持透明（宽度不变） */
	.kequn-list-item:not(.active) {
		background-color: #F0F4F8;
		color: #666666;
		/* 边框宽度已在基础样式统一，此处仅确认颜色 */
		border-color: transparent;
	}

	/* 标签选中状态：仅改边框颜色+背景+文字颜色，宽度不变 */
	.kequn-list-item.active {
		background-color: rgba(21, 112, 238, 0.1);
		border-color: #1570EE;
		/* 仅改颜色，宽度仍为2px */
		color: #1F2226;
	}

	.fengge-title .star-icon {
		width: 2.6667vw;
		/* 20px */
		height: 2.1333vw;
		/* 16px */
		margin-right: 0.8vw;
		/* 与文字间距6px，和之前星号一致 */
		/* 抵消标题左margin的16px，保证星号和“面向客群”星号视觉对齐 */
		margin-left: -1.3333vw;
		vertical-align: middle;
		display: inline-block;
		object-fit: contain;
	}

	.fengge-title {
		margin-top: 1.6vw !important;
		margin-bottom: 0 !important;
		/* 12px，覆盖原有margin-top */
	}

	/* 新增：风格选择盒子样式（无左padding，上下12px/右10px） */
	.fengge-item-container {
		padding: 1.6vw 1.3333vw 1.6vw 0;
		/* 上下12px、右10px、左0（去掉左padding） */
		margin-top: 1.6vw;
		/* 标题下方12px间距 */
		box-sizing: border-box;
		width: 100%;
	}

	.emoji-title {
		/* margin-top: 5.3333vw !important; */
		/* 40px = 40/7.5，包含上下padding的总间距 */
		margin-bottom: 2.1333vw !important;
		/* 标题与选项间距16px，可选优化 */
	}

	/* 是/否单选容器：横向排列，间距控制 */
	.emoji-select-container {
		display: flex;
		align-items: center;
		gap: 1.6vw;
		/* 选项之间间距20px，可按需调整 */
		padding: 0 2.1333vw;
		/* 匹配左侧16px margin，保证对齐 */
		margin-bottom: 4.2667vw;
		/* 底部预留间距，可选 */
	}

	/* 是/否选项基础样式：无位移核心（透明边框） */
	.emoji-select-item {
		padding: 1.3333vw 5.3333vw;
		/* 上下10px 左右40px */
		border-radius: 1.0667vw;
		/* 8px */
		font-family: SourceHanSansSC-regular;
		color: #666666;
		font-weight: 400;
		font-size: 2.6667vw;
		/* 20px */
		font-style: normal;
		text-decoration: none;
		text-align: center;
		line-height: 1;
		cursor: pointer;
		box-sizing: border-box !important;
		/* 核心：透明边框，宽度与选中状态一致，避免切换位移 */
		border: 0.2667vw solid transparent;
		/* 2px 透明边框 */
		background-color: #F0F4F8;
	}

	/* 是/否选项选中状态 */
	.emoji-select-item.active {
		background-color: rgba(21, 112, 238, 0.1);
		border-color: #1570EE;
		/* 仅改边框颜色，宽度不变 */
		color: #1F2226;
	}

	.word-count-title {
		margin-top: 5.3333vw !important;
		margin-bottom: 1.6vw !important;
	}

	/* 字数选择容器：横向排列，gap=1.6vw（和emoji容器一致） */
	.word-count-select-container {
		display: flex;
		align-items: center;
		gap: 1.6vw;
		padding: 0 2.1333vw;
		margin-bottom: 4.4vw;
		flex-wrap: wrap;
		/* 新增：确保选项垂直对齐一致 */
		align-items: stretch;
	}

	/* 字数选项基础样式：移除固定最小宽度，改为宽度自适应 */
	.word-count-select-item {
		padding: 1.3333vw 2.6667vw;
		/* 上下10px 左右20px */
		border-radius: 1.0667vw;
		/* 8px */
		font-family: SourceHanSansSC-regular;
		color: #666666;
		font-weight: 400;
		font-size: 2.6667vw;
		/* 20px */
		text-align: center;
		line-height: 1;
		cursor: pointer;
		box-sizing: border-box !important;
		border: 0.2667vw solid transparent;
		/* 核心：无位移 */
		background-color: #F0F4F8;
		/* 关键修改：移除min-width，改为宽度自适应 */
		width: auto;
		height: 6.4vw;
		/* 固定高度48px，保证对齐 */
		display: inline-flex;
		/* 改为inline-flex，宽度随内容自适应 */
		align-items: center;
		justify-content: center;
		/* 新增：限制最大宽度，避免输入过长数字撑太宽 */
		max-width: 16vw;
	}

	/* 自定义选项单独样式：进一步适配输入框宽度 */
	.custom-item {
		padding: 1.3333vw 1.3333vw !important;
		/* 缩小左右padding，适配输入框 */
		/* 输入框容器宽度随内容走，最小宽度仅适配“自定义”文字 */
		min-width: 8vw !important;
	}

	/* 自定义输入框样式：宽度随字符数自适应，不撑满 */
	.custom-word-input {
		/* 关键修改：移除width:100%，改为宽度自适应 */
		width: auto;
		min-width: 4vw;
		/* 最小宽度适配1位数字 */
		max-width: 12vw;
		/* 最大宽度适配4位数字（1000） */
		height: 100%;
		border: none;
		outline: none;
		background: transparent;
		font-family: SourceHanSansSC-regular;
		font-size: 2.6667vw;
		color: #1F2226;
		text-align: center;
		padding: 0 0.5333vw;
		/* 少量内边距，避免字符贴边 */
		margin: 0;
		box-sizing: border-box;
	}

	/* 保留选中状态样式（无需修改） */
	.word-count-select-item.active {
		background-color: rgba(21, 112, 238, 0.1);
		border-color: #1570EE;
		color: #1F2226;
	}

	.generate-btn {
		/* 宽400px=400/7.5≈53.3333vw，高60px=8vw */
		width: 53.3333vw;
		height: 8vw;
		/* 圆角16px=16/7.5≈2.1333vw */
		border-radius: 2.1333vw;
		/* 渐变背景 */
		background: linear-gradient(148.76deg, rgba(47, 255, 181, 1) 0%, rgba(30, 137, 255, 1) 100%);
		/* 字体样式 */
		font-family: SourceHanSansSC-medium;
		color: #FFFFFF;
		font-weight: 500;
		font-size: 3.2vw;
		/* 24px=24/7.5=3.2vw */
		letter-spacing: 0.2667vw;
		/* 2px=2/7.5≈0.2667vw */
		font-style: normal;
		text-decoration: none;
		text-align: center;
		/* 文字垂直居中 */
		line-height: 8vw;
		/* 与高度一致，实现垂直居中 */
		/* 居中显示 */
		margin: 0 auto;
		cursor: pointer;
		/* 可选：添加点击反馈 */
		transition: opacity 0.2s;
	}

	.generate-btn:active {
		opacity: 0.9;
	}

	.ai-topic-popup-container {
		/* 高度 = 100vh - 导航栏高度(11.7333vw) */
		height: calc(100vh - 11.7333vw);
		height: calc(100dvh - 11.7333vw);
		/* 圆角32px = 32/7.5 = 4.2667vw */
		border-top-left-radius: 4.2667vw;
		border-top-right-radius: 4.2667vw;
		/* 内边距：左右32px(4.2667vw) 上下40px(5.3333vw) */
		padding: 5.3333vw 4.2667vw;
		box-sizing: border-box;
		background: #FFFFFF;
		/* 弹窗背景（可选） */
		overflow-y: auto;
		/* 内容超出可滚动 */
	}

	/* 弹窗顶部栏：返回按钮+标题布局 */
	.ai-topic-popup-header {
		display: flex;
		align-items: center;
		/* 图片与文字水平居中（垂直对齐） */
		margin-bottom: 2.1333vw;
		/* 与内容区间距，可选 */
	}

	/* 弹窗返回按钮 */
	.back-btn-popup {
		width: 3.2vw;
		/* 24px = 24/7.5 */
		/* height: 3.2vw; */
		/* 24px */
		cursor: pointer;
		flex-shrink: 0;
		/* 防止压缩 */
	}

	/* 弹窗返回按钮图标 */
	.back-icon-popup {
		width: 100%;
		height: 100%;
		object-fit: contain;
	}

	/* AI选题标题样式 */
	.ai-topic-title {
		margin-left: 1.0667vw;
		/* 与图片间距8px = 8/7.5 */
		opacity: 0.9;
		font-family: AlimamaShuHeiTi-Bold;
		color: #1B3154;
		font-weight: 700;
		font-size: 3.7333vw;
		/* 28px = 28/7.5 */
		letter-spacing: -0.1333vw;
		/* -1px = -1/7.5 */
		font-style: normal;
		text-decoration: none;
		text-align: left;
	}

	.ai-topic-divider {
		width: 100%;
		height: 0.2667vw;
		/* 2px = 2/7.5 */
		background-color: #E4E8EC;
	}

	/* 新增：横向滚动盒子 */
	.ai-topic-scroll-box {
		margin-top: 2.1333vw;
		/* 横线下方16px */
		padding: 2.1333vw 3.2vw;
		/* 上下16px 左右24px */
		box-sizing: border-box;
		width: 100%;
		/* 横向滚动核心样式 */
		overflow-x: auto;
		white-space: nowrap;
		/* 禁止换行 */
		-webkit-overflow-scrolling: touch;
		/* 移动端顺滑滚动 */
		/* 隐藏滚动条（可选，优化视觉） */
		scrollbar-width: none;
		/* 火狐 */
	}

	/* 隐藏Chrome滚动条 */
	.ai-topic-scroll-box::-webkit-scrollbar {
		display: none;
	}

	/* 新增：选题标签文字样式 */
	.ai-topic-tag {
		display: inline-block;
		/* 横向排列 */
		margin-right: 2.1333vw;
		/* 文字间距16px */
		/* 文字样式 */
		font-family: SourceHanSansSC-bold;
		color: #1B3154;
		font-weight: 700;
		font-size: 3.7333vw;
		/* 28px = 28/7.5 */
		font-style: normal;
		text-decoration: none;
		text-align: center;
		/* 可选：防止文字挤压 */
		line-height: 1;
	}

	.ai-topic-list-container {
		width: 100%;
		/* 占据弹窗剩余所有空间 */
		flex: 1;
		/* 超出可纵向滚动 */
		overflow-y: auto;
		/* 与上方横向盒子间距16px */
		margin-top: 2.1333vw;
		box-sizing: border-box;
	}

	/* 列表项基础样式 */
	.ai-topic-list-item {
		width: 100%;
		padding: 2.4vw 3.2vw;
		/* 上下18px=2.4vw 左右24px=3.2vw */
		box-sizing: border-box;
		/* 文字样式 */
		opacity: 0.8;
		font-family: SourceHanSansSC-medium;
		color: #000000;
		font-weight: 500;
		font-size: 3.2vw;
		/* 24px=3.2vw */
		font-style: normal;
		text-decoration: none;
		text-align: left;
		/* 文字超出自动换行 */
		word-wrap: break-word;
		word-break: break-all;
		line-height: 1.5;
		/* 优化换行后行高 */
		/* 默认只有下分割线 */
		border-bottom: 0.2667vw solid #E4E8EC;
		/* 复用分割线颜色，2px=0.2667vw */
		cursor: pointer;
	}

	/* 第一个列表项：额外加顶部分割线 */
	.ai-topic-list-item.first-item {
		border-top: 0.2667vw solid #E4E8EC;
	}

	.ai-topic-list-item.active {
		color: #1570EE;
		/* 选中时文字颜色改为指定值 */
		/* 其余样式与未选中一致，无需重复定义 */
	}

	/* 调整弹窗主体容器为flex布局，让列表占据剩余空间 */
	.ai-topic-popup-container {
		height: calc(100vh - 11.7333vw);
		height: calc(100dvh - 11.7333vw);
		border-top-left-radius: 4.2667vw;
		border-top-right-radius: 4.2667vw;
		padding: 5.3333vw 4.2667vw;
		box-sizing: border-box;
		background: #FFFFFF;
		/* 新增：flex纵向布局，让列表占剩余空间 */
		display: flex;
		flex-direction: column;
		/* 原overflow-y: auto; 可移除，由子容器滚动 */
		overflow: hidden;
	}
</style>